import type { ReactNode } from 'react'
import { useMemo } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { INTL_DAY_LONG_MONTH_YEAR } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { useCurrencyFormatter } from 'hooks/useNumberFormatters'
import { ONE_POINT_PROMO_DATE } from 'lib/maldivesCharter/classicRewardPricing'

export { ONE_POINT_PROMO_DATE }
export const promoMessages = defineMessages({
  title: {
    id: 'NG3KuXDbETXnrn_dDGIj',
    defaultMessage: 'One-way flight to the Maldives for <em>1 Société Point + {fare} pp</em>',
    description: 'Headline for the Maldives one-point flight promotion with the redemption price emphasised in italics.',
  },
  terms: {
    id: 'NYiISpuKUzfyHa-h7FIj',
    defaultMessage: 'T&Cs apply.',
    description: 'Link to the promotion terms for the Maldives one-point charter flight sale.',
  },
})

const currencyOptions = { currency: 'AUD' }
const emphasis = (chunks: ReactNode) => <em>{chunks}</em>

export function usePromoValues() {
  const intl = useIntl()
  const formatAudCurrency = useCurrencyFormatter(currencyOptions)
  const fare = formatAudCurrency(100, 'rounded')
  const date = intlDateFormatter(ONE_POINT_PROMO_DATE, INTL_DAY_LONG_MONTH_YEAR, intl.locale)
  return useMemo(() => ({ fare, date, em: emphasis }), [fare, date])
}
